"use strict";

var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault");
Object.defineProperty(exports, "__esModule", {
  value: true
});
exports["default"] = void 0;
var _react = _interopRequireDefault(require("react"));
var _semanticUiReact = require("semantic-ui-react");
var VariationSelection = function VariationSelection(_ref) {
  var variations = _ref.variations,
    selectedVariation = _ref.selectedVariation,
    onSelectVariation = _ref.onSelectVariation,
    _ref$showDivider = _ref.showDivider,
    showDivider = _ref$showDivider === void 0 ? true : _ref$showDivider,
    checkoutDisabled = _ref.checkoutDisabled;
  return /*#__PURE__*/_react["default"].createElement("div", {
    className: "item-cart-variation-selection"
  }, showDivider && /*#__PURE__*/_react["default"].createElement(_semanticUiReact.Divider, null), /*#__PURE__*/_react["default"].createElement("div", {
    className: "variation-selection-header"
  }, /*#__PURE__*/_react["default"].createElement("h5", null, "CHOOSE A TYPE"), /*#__PURE__*/_react["default"].createElement(_semanticUiReact.Label, {
    color: "blue"
  }, "REQUIRED")), /*#__PURE__*/_react["default"].createElement(_semanticUiReact.Form, null, variations.map(function (_ref2, index) {
    var name = _ref2.name,
      price = _ref2.price;
    return /*#__PURE__*/_react["default"].createElement("div", {
      className: "variation-selection-radio",
      key: name
    }, /*#__PURE__*/_react["default"].createElement(_semanticUiReact.Form.Field, null, /*#__PURE__*/_react["default"].createElement(_semanticUiReact.Radio, {
      disabled: checkoutDisabled,
      label: name,
      name: "variation",
      value: "this",
      checked: "".concat(name).concat(price) === "".concat(selectedVariation.name).concat(selectedVariation.price),
      onChange: function onChange() {
        return onSelectVariation(index);
      }
    })), /*#__PURE__*/_react["default"].createElement("div", null, price && price !== 0 ? "$".concat(price.toFixed(2)) : '-'));
  })));
};
var _default = VariationSelection;
exports["default"] = _default;